// Module
var code = `<template class="comp-icon">
	
	<!-- Slot -->
	<slot></slot>
</template>`;
// Exports
export default code;